import { Axe, Scissors, Disc3, CloudLightning, Trees, ArrowRight } from "lucide-react";
import { SERVICES } from "../../lib/content";

const ICONS = { Axe, Scissors, Disc3, CloudLightning, Trees };

const ServiceCard = ({ service }) => {
  const Icon = ICONS[service.icon];
  const featured = service.featured;
  return (
    <div
      data-testid={`service-card-${service.id}`}
      className={`group relative overflow-hidden rounded-xl border border-gold/20 hover:border-gold/60 transition-all duration-500 hover:-translate-y-1 shadow-lg shadow-black/50 ${
        featured ? "md:col-span-2 md:row-span-1 min-h-[320px]" : "bg-[#111111] min-h-[320px]"
      }`}
    >
      {featured && service.image && (
        <>
          <img src={service.image} alt={service.title} className="absolute inset-0 w-full h-full object-cover opacity-40 group-hover:opacity-55 group-hover:scale-105 transition-all duration-700" />
          <div className="absolute inset-0 bg-gradient-to-t from-black via-black/70 to-black/30" />
        </>
      )}
      <div className="relative z-10 p-8 flex flex-col h-full">
        <div className="w-14 h-14 rounded-lg bg-gold/10 border border-gold/30 flex items-center justify-center text-gold group-hover:bg-gold group-hover:text-black transition-all duration-300">
          <Icon size={26} />
        </div>
        <h3 className="mt-6 font-serif text-2xl text-white">{service.title}</h3>
        <p className="mt-3 text-gray-400 text-sm leading-relaxed flex-grow">{service.desc}</p>
        <a href="#estimate" className="mt-5 inline-flex items-center gap-2 text-gold text-sm uppercase tracking-widest opacity-80 group-hover:opacity-100 group-hover:gap-3 transition-all">
          Request This <ArrowRight size={15} />
        </a>
      </div>
    </div>
  );
};

export const Services = () => {
  return (
    <section id="services" data-testid="services-section" className="relative py-24 md:py-32 bg-[#0A0A0A]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <p className="font-cursive text-gold text-2xl md:text-3xl">What We Do</p>
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-white mt-1">Complete Tree Care Services</h2>
          <div className="gold-divider w-40 mx-auto mt-6" />
          <p className="mt-6 text-gray-400">From routine maintenance to emergency response — one crew for every tree job on your property.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {SERVICES.map((s) => (
            <ServiceCard key={s.id} service={s} />
          ))}
        </div>
      </div>
    </section>
  );
};
